const Signin = () => {
    return (
        <div className="text-center p-6">
            <h1 className="text-3xl font-bold text-purple-600">📊 统计信息</h1>
            <p className="text-gray-700 mt-2">看看我们的销量数据吧！</p>
        </div>
    );
};

export default Signin;